import React from "react";

import styles from "./Questionnaire.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";
import { Link } from "react-router";
import QuestionnareTextarea from "../../../UI/Questionnary/QuestionnaryTextarea/QuestionnaryTextarea";
import QuestionnareInput from "../../../UI/Questionnary/QuestionnareInput/QuestionnareInput";

const DEFAULT_QUESTIONARY = {
  name: "",
  surname: "",
  tel: "+7",
  email: "",
  brand: "",
  site: "",
  socialMedia: "",
  businesDescription: "",
  samples: "",
};

const Questionnaire: React.FC = () => {
  const [questionnaryData, setQuestionnaryData] = React.useState(DEFAULT_QUESTIONARY);
  const [isChecked, setIsChecked] = React.useState(false);

  const handleInputChange = (fieldName: string, value: string) => {
    setQuestionnaryData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const onFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log(questionnaryData);
  };

  return (
    <section>
      <div className="container">
        <div className={styles.info}>
          <PreviousPage currentPage="Анкета для молодых дизайнеров" title="Анкета для молодых дизайнеров" />
          <p className={styles.text}>
            Молодым дизайнерам часто приходится сталкиваться со множеством трудностей, вам это знакомо? <br /> Наша компания
            предлагает для вас программу поддержки молодых российских дизайнеров! <br /> Для участия необходимо заполнить анкету,
            после проверки модератором с вами свяжется наш менеджер. <br /> Образцы предаставляются бесплатно, доставка
            осуществляется после 100% оплаты транспортных услуг.
          </p>
          <div className={styles.more}>
            <Link to="/">Подробнее</Link>
          </div>
        </div>
        <div className={styles.body}>
          <form onSubmit={onFormSubmit} className={styles.form}>
            <h3 className={styles.title}>Анкета</h3>
            <div className={styles.fields}>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Имя"
                  name="name"
                  isRequired={true}
                  defaultValue={questionnaryData.name}
                  onChange={(value) => handleInputChange("name", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Фамилия"
                  name="surname"
                  isRequired={true}
                  defaultValue={questionnaryData.surname}
                  onChange={(value) => handleInputChange("surname", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Телефон"
                  name="tel"
                  isRequired={true}
                  isTel={true}
                  defaultValue={questionnaryData.tel}
                  onChange={(value) => handleInputChange("tel", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="E-mail"
                  name="email"
                  isRequired={true}
                  isEmail={true}
                  defaultValue={questionnaryData.email}
                  onChange={(value) => handleInputChange("email", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Ваш бренд"
                  name="brand"
                  isRequired={true}
                  defaultValue={questionnaryData.brand}
                  onChange={(value) => handleInputChange("brand", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Сайт"
                  name="site"
                  isRequired={false}
                  defaultValue={questionnaryData.site}
                  onChange={(value) => handleInputChange("site", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareTextarea
                  label="Социальные сети бренда"
                  name="socialMedia"
                  isRequired={false}
                  onChange={(value) => handleInputChange("socialMedia", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareTextarea
                  label="Опишите ваш бизнес"
                  name="businesDescription"
                  isRequired={true}
                  onChange={(value) => handleInputChange("businesDescription", value)}
                />
              </div>
              <div className={styles.field}>
                <QuestionnareInput
                  label="Интересующие образцы тканей"
                  name="samples"
                  isRequired={true}
                  defaultValue={questionnaryData.samples}
                  onChange={(value) => handleInputChange("samples", value)}
                />
              </div>
            </div>
            <p className={styles.agreement}>
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                id="designer-agreement"
              />
              <Link to="/privacy">
                Нажимая кнопку, я даю согласие на обработку моих персональных данных с целью рассмотрения анкеты и возможного
                заключения договора о сотрудничестве в соответствии с Политикой конфиденциальности
              </Link>
            </p>
            <div className={styles.samples}>
              <button type="submit">Запросить образцы</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Questionnaire;
